import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'
import Modal from 'react-responsive-modal'
import BannerActions from '../../Redux/BannerRedux'
import PresetActions from '../../Redux/PresetRedux'
import FormCreate from '../../Containers/Travypass/FormCreate'
import UpdateContent from '../../Containers/Travypass/UpdateContent'
import UpdateImage from '../../Containers/Travypass/UpdateImage'

class ManageTravypass extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      general_markup_travypass: props.preset.dataPresetOrder.general_markup_travypass,
      tab: 'Banner',
      filter: {
        type: 'travypass',
        title: ''
      },
      reverse: false,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._fetchBanner()
    setTimeout(() => {
      this.setState({ general_markup_travypass: this.props.preset.dataPresetOrder.general_markup_travypass })
    }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    if (this.state.tab === 'Banner' && !modalId) {
      this._fetchBanner()
    }
  }

  _changeTab = (tab) => {
    this.setState({ tab })
  }

  _fetchBanner = () => {
    this.props.getBanners(this.state.filter)
  }

  _updatePreset= (event) => {
    event.preventDefault()
    const data = {
      general_markup_travypass: this.state.general_markup_travypass
    }
    this.props.updatePreset(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 100) {
      val = 100
    } else if (parseFloat(val) < -100) {
      val = -100
    }
    this.setState({ general_markup_travypass: val })
  }

  _filterChange = (event, field) => {
    const val = event.target.value
    let filter = {...this.state.filter}
    filter[field] = val
    this.setState({ filter })

    if (field === 'title') {
      $.expr[':'].contains = function (a, i, m) {
        return $(a).text().toUpperCase()
            .indexOf(m[3].toUpperCase()) >= 0
      }
      if (val) {
        $('td[data-filter="title"]:not(:contains("' + val + '"))').parent().hide()
        $('td[data-filter="title"]:contains("' + val + '")').parent().show()
      } else {
        $('tr:hidden').show()
      }
    }
  }

  _reverseOrder = () => {
    this.setState({
      reverse: !this.state.reverse
    })

    $('tbody').each(function (elem, index) {
      var arr = $.makeArray($('tr', this).detach())
      arr.reverse()
      $(this).append(arr)
    })
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _delete = () => {
    this.props.deleteBanner(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  render () {
    const { banner } = this.props
    const { preset } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Manage Travelinpod {this.state.tab}
              { banner.fetching && <div className='badge badge-info ml-2'>Loading ...</div> }
            </h3>
            {
              this.state.tab === 'Banner'
              ? <button className='btn btn-primary ml-auto' onClick={() => this._toggleModal('create-travypass-banner')}>Create New Banner</button>
              : <button disabled className='btn btn-primary ml-auto'>Create New Banner</button>
            }
          </div>
          <div className='btn-group mb-3' role='group'>
            <button
              className={`btn btn-primary ${this.state.tab === 'Banner' ? 'active' : ''}`}
              onClick={() => this._changeTab('Banner')}>Banner
            </button>
            <button
              className={`btn btn-primary ${this.state.tab === 'Markup' ? 'active' : ''}`}
              onClick={() => this._changeTab('Markup')}>Markup
            </button>
          </div>
          {
            this.state.tab === 'Banner' &&
            <div className='form-inline mb-3'>
              <div className='form-group'>
                <label htmlFor='title' className='control-label mr-2'>Title</label>
                <input type='text' className='form-control' placeholder='Banner Title' defaultValue={this.state.filter.title} onChange={(event) => this._filterChange(event, 'title')} />
              </div>
            </div>
          }
        </header>
        {
          this.state.tab === 'Banner'
          ? <div className='section'>
            <div className='card'>
              {
                !(banner.fetching || banner.processing) && banner.err &&
                <div className='alert alert-danger'>{banner.err}</div>
              }
              <div className='card-block'>
                <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th>Title: </th>
                      <th role='button' onClick={() => this._reverseOrder()}>Priority <span className='badge badge-info'><i className={`fas fa-${this.state.reverse ? 'sort-numeric-down' : 'sort-numeric-up'}`} /></span></th>
                      <th className='text-center'>Web</th>
                      <th className='text-center'>Mobile</th>
                      <th className='text-center'>Update</th>
                      <th className='text-center'>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      (banner.data && banner.data.length) ? banner.data.map((item, i) => (
                        <tr key={i}>
                          <td data-filter='title'>{ item.title || '-' }</td>
                          <td className='text-center'>{ item.priority || '-' }</td>
                          <td className='text-center'>
                            {
                              item.image_url.web
                              ? <img src={item.image_url.web} alt='' className='img img-responsive' height='65px' />
                              : '- No Image -'
                            }
                          </td>
                          <td className='text-center'>
                            {
                              item.image_url.mobile
                              ? <img src={item.image_url.mobile} alt='' className='img img-responsive' height='65px' />
                              : '- No Image -'
                            }
                          </td>
                          <td className='d-flex justify-content-around'>
                            <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'update-travypass-content')}>
                              <i className='fas fa-edit' /> Content
                            </button>
                            <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-travypass-image')}>
                              <i className='fa fa-image' /> Image
                            </button>
                          </td>
                          <td className='text-center'>
                            <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-travypass-banner')}>
                              <i className='fa fa-trash' />
                            </button>
                          </td>
                        </tr>
                      ))
                      : <tr>
                        <td colSpan='8' className='text-center'>- NO DATA -</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          : <div className='section'>
            <div className='card'>
              <div className='card-block'>
                <div className='form-inline'>
                  <div className='form-group mr-2'>
                    <label className='control-label mr-2 mb-2'>General Markup: </label><strong className='mb-2'>{preset.dataPresetOrder.general_markup_travypass} %</strong>
                  </div>
                  <div className='form-group mr-2'>
                    <button type='button' className='btn btn-dark btn-sm btn-link mb-2' onClick={() => this._toggleModal('edit-general-markup-travypass')}>Edit</button>
                  </div>
                  <div className='form-group mb-2'>
                    {
                      preset.fetchingPresetOrder &&
                      <span className='badge badge-info'>Processing...</span>
                    }
                    {
                      preset.errPresetOrder &&
                      <span className='badge badge-danger'>
                        {preset.errPresetOrder}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <section>
          {/* CREATE TRAVYPASS BANNER */}
          <Modal open={this.state.showModal === 'create-travypass-banner'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormCreate closeModal={() => this._toggleModal()} />
          </Modal>

          {/* EDIT TRAVYPASS BANNER CONTENT */}
          <Modal open={this.state.showModal === 'update-travypass-content'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateContent detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* EDIT TRAVYPASS BANNER IMAGE */}
          <Modal open={this.state.showModal === 'update-travypass-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <UpdateImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          {/* DELETE TRAVYPASS BANNER */}
          <Modal open={this.state.showModal === 'delete-travypass-banner'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h3>Delete Banner?</h3>
              </div>
              <div className='text-center'>
                <h4>
                  { this.state.detail.title || '-' }
                </h4>
              </div>
              <div className='text-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </section>
          </Modal>

          {/* UPDATE GENERAL MARKUP TRAVYPASS */}
          <Modal open={this.state.showModal === 'edit-general-markup-travypass'} onClose={this._toggleModal} closeOnOverlayClick>
            <div className='section' style={{ width: '20vw' }}>
              <div className='title-block'>
                <h4 className='title mr-auto'>General Markup</h4>
              </div>
              <form onSubmit={(event) => this._updatePreset(event)}>
                <div className='form-group'>
                  <div className='input-group'>
                    <input
                      onChange={(event) => this._valueChange(event)}
                      type='number'
                      name='value'
                      required
                      step='any'
                      max={100}
                      className='form-control'
                      value={this.state.general_markup_travypass}
                    />
                    <div className='input-group-append'>
                      <span className='input-group-text'>%</span>
                    </div>
                  </div>
                </div>
                <div className='form-group text-right'>
                  <button type='button' onClick={() => this._toggleModal()} className='btn btn-secondary ml-auto'>Cancel</button>
                  <button type='submit' className='btn btn-primary ml-2'>Submit</button>
                </div>
              </form>
            </div>
          </Modal>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  banner: state.banner,
  preset: state.preset
})

const dispatchToProps = (dispatch) => ({
  getBanners: (filter) => dispatch(BannerActions.bannerRequest(filter)),
  deleteBanner: (id) => dispatch(BannerActions.bannerDeleteRequest({id})),
  updatePreset: (data) => dispatch(PresetActions.presetOrderUpdateRequest(data))
  // getPreset: () => dispatch(PresetActions.presetOrderRequest())
})

export default connect(stateToProps, dispatchToProps)(ManageTravypass)



// WEBPACK FOOTER //
// ./src/Pages/Travypass/ManageTravypass.js